import React, { useContext, useEffect, useState } from "react";
import {
  Typography,
  Divider,
  OldButton as Button,
  Stack,
  TextInput,
  ModalContent,
} from "digiwash-components";

import Modal from "../ReactNativeModal";

import { CouponContext } from "../../contexts/coupon";
import { EVENT_TYPES, logEvent } from "../../helpers/analytics-helper";
import useScrollLock from "../../hooks/useScrollLock";
import useCart from "../../ducks/cart/hooks/useCart";

function ModalCoupon() {
  let [couponInput, setCouponInput] = useState(undefined);
  let { isCouponModalOpen, setCouponModalOpen } = useContext(CouponContext);
  let { coupon, revalidateCart } = useCart();
  let { enable, disable } = useScrollLock();
  let canSubmitForm = !!couponInput && !coupon.loading;
  let onSubmit = () => {
    if (canSubmitForm) {
      logEvent(EVENT_TYPES.BUTTON_ADD_COUPON);

      coupon
        .add(couponInput)
        .then(() => {
          setCouponModalOpen(false);
          revalidateCart();
        })
        .catch(console.error)
        .finally(dismiss);
    }
  };
  let dismiss = () => {
    setCouponModalOpen(false);
  };
  useEffect(() => {
    if (isCouponModalOpen) {
      enable();
    } else {
      disable();
    }
  }, [isCouponModalOpen]);

  return (
    <Modal
      isVisible={isCouponModalOpen}
      onSwipeComplete={dismiss}
      onBackdropPress={dismiss}
      swipeDirection={["down"]}
      style={{ justifyContent: "flex-end", margin: 0 }}
      // For web
      onRequestClose={dismiss}
    >
      <ModalContent title="کد تخفیف" dismiss={dismiss}>
        <Typography alignment="center" color="common.black">
          کد تخفیف خود را وارد کنید
        </Typography>
        <Divider size="l" />
        <TextInput
          onChangeText={setCouponInput}
          value={couponInput}
          placeholder="کد تخفیف"
          onSubmitEditing={onSubmit}
        />
        <Divider size="l" />
        <Button
          onPress={onSubmit}
          size="l"
          type="circle-like"
          bg="green.main"
          disabled={!canSubmitForm}
        >
          <Stack distribution="center">
            <Typography color="common.white" ff="mainBold">
              ثبت
            </Typography>
          </Stack>
        </Button>
      </ModalContent>
    </Modal>
  );
}

export default ModalCoupon;
